import _dimensionType from './_dimensionType';

function dimensions (_val) {
  if (!arguments.length) return this.__attrs__.dimensions;
  if (!Array.isArray(_val)) {
    _val = [_val];
  }
  this.__attrs__.dimensions = _val.map(function (v) { return _dimensionType(v); });
  return this;
}

export default dimensions;


// WEBPACK FOOTER //
// ./layouts/default/dimensions.js